// FETCH ALL ACCESSORIES MASTER
export const FETCH_BARCODE_MASTER_REQUEST = 'FETCH_BARCODE_MASTER_REQUEST';
export const FETCH_BARCODE_MASTER_SUCCESS = 'FETCH_BARCODE_MASTER_SUCCESS';
export const FETCH_BARCODE_MASTER_FAILURE = 'FETCH_BARCODE_MASTER_FAILURE';

// FETCH ALL ACCESSORIES MASTER
export const FETCH_BARCODE_MASTER_SALES_ORDER_REQUEST = 'FETCH_BARCODE_MASTER_SALES_ORDER_REQUEST';
export const FETCH_BARCODE_MASTER_SALES_ORDER_SUCCESS = 'FETCH_BARCODE_MASTER_SALES_ORDER_SUCCESS';
export const FETCH_BARCODE_MASTER_SALES_ORDER_FAILURE = 'FETCH_BARCODE_MASTER_SALES_ORDER_FAILURE';

export const FETCH_BARCODE_MASTER_STYLE_MASTER_REQUEST = 'FETCH_BARCODE_MASTER_STYLE_MASTER_REQUEST';
export const FETCH_BARCODE_MASTER_STYLE_MASTER_SUCCESS = 'FETCH_BARCODE_MASTER_STYLE_MASTER_SUCCESS';
export const FETCH_BARCODE_MASTER_STYLE_MASTER_FAILURE = 'FETCH_BARCODE_MASTER_STYLE_MASTER_FAILURE';

export const FETCH_BARCODE_MASTER_SUB_STYLE_REQUEST = 'FETCH_BARCODE_MASTER_SUB_STYLE_REQUEST';
export const FETCH_BARCODE_MASTER_SUB_STYLE_SUCCESS = 'FETCH_BARCODE_MASTER_SUB_STYLE_SUCCESS';
export const FETCH_BARCODE_MASTER_SUB_STYLE_FAILURE = 'FETCH_BARCODE_MASTER_SUB_STYLE_FAILURE';

export const FETCH_BARCODE_COPY_FROM_STYLE_REQUEST = 'FETCH_BARCODE_COPY_FROM_STYLE_REQUEST';
export const FETCH_BARCODE_COPY_FROM_STYLE_SUCCESS = 'FETCH_BARCODE_COPY_FROM_STYLE_SUCCESS';
export const FETCH_BARCODE_COPY_FROM_STYLE_FAILURE = 'FETCH_BARCODE_COPY_FROM_STYLE_FAILURE';

// CREATE ACCESSORIES MASTER
export const CREATE_BARCODE_MASTER_REQUEST = 'CREATE_BARCODE_MASTER_REQUEST';
export const CREATE_BARCODE_MASTER_SUCCESS = 'CREATE_BARCODE_MASTER_SUCCESS';
export const CREATE_BARCODE_MASTER_FAILURE = 'CREATE_BARCODE_MASTER_FAILURE';

// CREATE ACCESSORIES MASTER
export const CREATE_BARCODE_MASTER_WITH_GRID_REQUEST = 'CREATE_BARCODE_MASTER_WITH_GRID_REQUEST';
export const CREATE_BARCODE_MASTER_WITH_GRID_SUCCESS = 'CREATE_BARCODE_MASTER_WITH_GRID_SUCCESS';
export const CREATE_BARCODE_MASTER_WITH_GRID_FAILURE = 'CREATE_BARCODE_MASTER_WITH_GRID_FAILURE';

// UPDATE ACCESSORIES MASTER
export const UPDATE_BARCODE_MASTER_REQUEST = 'UPDATE_BARCODE_MASTER_REQUEST';
export const UPDATE_BARCODE_MASTER_SUCCESS = 'UPDATE_BARCODE_MASTER_SUCCESS';
export const UPDATE_BARCODE_MASTER_FAILURE = 'UPDATE_BARCODE_MASTER_FAILURE';

// FETCH SINGLE STATE OF ACCESSORIES MASTER
export const FETCH_SINGLE_BARCODE_MASTER_REQUEST = 'FETCH_SINGLE_BARCODE_MASTER_REQUEST';
export const FETCH_SINGLE_BARCODE_MASTER_SUCCESS = 'FETCH_SINGLE_BARCODE_MASTER_SUCCESS';
export const FETCH_SINGLE_BARCODE_MASTER_FAILURE = 'FETCH_SINGLE_BARCODE_MASTER_FAILURE';


export const FETCH_PROGRAM_CAT_PRINT_REQUEST = 'FETCH_PROGRAM_CAT_PRINT_REQUEST';
export const FETCH_PROGRAM_CAT_PRINT_SUCCESS = 'FETCH_PROGRAM_CAT_PRINT_SUCCESS';
export const FETCH_PROGRAM_CAT_PRINT_FAILURE = 'FETCH_PROGRAM_CAT_PRINT_FAILURE';

// DELETE ACCESSORIES MASTER
export const DELETE_BARCODE_MASTER_REQUEST = 'DELETE_BARCODE_MASTER_REQUEST';
export const DELETE_BARCODE_MASTER_SUCCESS = 'DELETE_BARCODE_MASTER_SUCCESS';
export const DELETE_BARCODE_MASTER_FAILURE = 'DELETE_BARCODE_MASTER_FAILURE';

// DELETE ACCESSORIES MASTER
export const DELETE_BARCODE_BEFORE_UPDATE_REQUEST = 'DELETE_BARCODE_BEFORE_UPDATE_REQUEST';
export const DELETE_BARCODE_BEFORE_UPDATE_SUCCESS = 'DELETE_BARCODE_BEFORE_UPDATE_SUCCESS';
export const DELETE_BARCODE_BEFORE_UPDATE_FAILURE = 'DELETE_BARCODE_BEFORE_UPDATE_FAILURE';

export const RESET_BARCODE_IMG_MASTER_INFO = 'RESET_BARCODE_IMG_MASTER_INFO';

export const RESET_BARCODE_MASTER_INFO = 'RESET_BARCODE_MASTER_INFO';

export const CREATE_BARCODE_MASTER_FORM = 'CREATE_BARCODE_MASTER_FORM';
export const CREATE_BARCODE_IMAGE_MASTER_FORM = 'CREATE_BARCODE_IMAGE_MASTER_FORM';

export const UPDATE_BARCODE_MASTER_FORM = 'UPDATE_BARCODE_MASTER_FORM';

// NAVIGATE TO SIZE RATIO COMPONENT
export const NAVIGATE_SIZE_RATIO = 'NAVIGATE_SIZE_RATIO';

// NAVIGATE TO ACCESSORIES MASTER COMPONENT
export const NAVIGATE_BARCODE_MASTER = 'NAVIGATE_BARCODE_MASTER';

export const ADD_IMAGE_BARCODE_MODAL = 'ADD_IMAGE_BARCODE_MODAL';

export const SHOW_ALL_SUB_STYLE_COLOR = 'SHOW_ALL_SUB_STYLE_COLOR';

export const SET_TEMP_GENERATE_GRID_DATA = 'SET_TEMP_GENERATE_GRID_DATA';



